const defaultState = {
    error: null,
    fetching: false,
    fetched: false
};

const postUploadFileToPresignedUrl = (state = defaultState, action) => {
    switch (action.type) {
        case 'UPLOAD_FILE_TO_PRESIGNED_URL_PENDING': {
            return {
                ...state, error: null, fetching: true
            };
        }
        case 'UPLOAD_FILE_TO_PRESIGNED_URL_FULFILLED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: null,
                response: action.payload,
            };
        }
        case 'UPLOAD_FILE_TO_PRESIGNED_URL_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: false,
                error: action.payload
            };
        }
        default: {
            break;
        }
    }

    return state;
};

export default postUploadFileToPresignedUrl;


// WEBPACK FOOTER //
// ./src/reducers/postUploadFileToPresignedUrl.js